import type { College } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const THE_COST_STRINGS = appStrings.modules.college.theCost;

export const useAgentContext = (college: College) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'The Cost',
    description:
      'Tuition and financial data including cost by family income, key cost figures, and net price calculator link',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Cost by Family Income',
    display: 'Two-column data table with family income bracket and average annual cost',
    detail: THE_COST_STRINGS.header.costByFamilyIncomeTooltip,
    data: {
      '$0-$30k': college.net_price_income_level_0_30000,
      '$30k-$48k': college.net_price_income_level_30001_48000,
      '$48k-$75k': college.net_price_income_level_48001_75000,
      '$75k-$110k': college.net_price_income_level_75001_110000,
      '$110k+': college.net_price_income_level_110001_plus,
    },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Cost Figures',
    display: 'Icon line items with tooltip explanations, shown alongside the table',
    detail: [
      THE_COST_STRINGS.costFigureTitles.inStateTuitionTooltip,
      THE_COST_STRINGS.costFigureTitles.outOfStateTuitionTooltip,
      THE_COST_STRINGS.costFigureTitles.roomAndBoardTooltip,
      THE_COST_STRINGS.costFigureTitles.averageFinancialAidTooltip,
    ].join('\n\n'),
    data: {
      tuition_in_state: college.tuition_in_state,
      tuition_out_of_state: college.tuition_out_of_state,
      room_and_board: college.room_and_board,
      average_financial_aid: college.average_financial_aid,
    },
  });
};
